import { FunctionUtils } from '../../pdr/utils/FunctionUtils.js';
export const {
  defer,
  debounce
} = new FunctionUtils();